import React from 'react'
import './index.less'
import {AppForm,AppRow,AppButton,AppAction} from 'qcc'

export interface IAppFormLayoutContext {
	appForm?:AppForm;
	setAppForm?:(appForm?:AppForm)=>void
}
export const AppFormLayoutContext = React.createContext<IAppFormLayoutContext>({} as IAppFormLayoutContext)

export interface AppFormLayoutProps {
    exportRef?:(self?:AppFormLayout)=>void
    defaultButton?:boolean
    saveActionCode?:string
    mode?:number
}

export class AppFormLayout extends React.Component<AppFormLayoutProps>{
    state = {appForm:null as AppForm}

    async componentDidMount(){
		this.props.exportRef && this.props.exportRef(this);
	}

    static Header : React.FC<{children?:any}> = props =>{
        return <div className='app-form-layout-header'>{props.children}</div>
    }


    static Footer : React.FC<{children?:any}> = props =>{
        return <div className='app-form-layout-footer'>{props.children}</div>
    }


    static Form : React.FC<{children?:any}> = props =>{
        return (<div className='app-form-layout-content'><div className='app-form-layout-content-inner'>
                <AppFormLayoutContext.Consumer>
                    {consumer =>{
                        return React.Children.map(props.children, (child: any) =>{
                            return child.type === AppForm ? React.cloneElement(child, {exportRef: consumer.setAppForm}) 
                                                            : child;
                            })
                    }}
                </AppFormLayoutContext.Consumer>
        </div></div>)
    }

    setAppForm = (appForm?:AppForm) =>{
        this.setState({appForm})
    }

    saveAppForm = async ()=>{
        if(this.state.appForm.save) return this.state.appForm.save();
        
        return false;
    }

    renderDefaultFooter = () =>{
        if(this.props.defaultButton){
            return (<div className='app-form-layout-footer'>
                        <AppRow>
                            {this.props.mode === 3?null :
                              <AppButton 
                              label="保存" 
                              type='primary' 
                              actionCode={this.props.saveActionCode} 
                              action = {this.saveAppForm}
                              /> 
                        }   
                          
                            <AppButton label="关闭"  action = {AppAction.closeDialog}/>
                        </AppRow>
                </div>)
        }
        
        return null;
    }

    render () {
        return (<AppFormLayoutContext.Provider value={{setAppForm:this.setAppForm,appForm:this.state.appForm}}>
        <div className='app-form-layout-container'>
            <div className='app-form-layout-inner'>
                {this.props.children}
                {this.renderDefaultFooter()}
            </div>
        </div>
    </AppFormLayoutContext.Provider>)
    }
}


export interface AppFormPageProps {
    id?:string
    mode?:number
    formData?:any
    extraData?:any
    afterSave?:()=>void
}






// WEBPACK FOOTER //
// ./src/qcc/AppFormLayout/index.tsx